import React, { Component } from "react";
import { Parse } from "parse";
import { connect } from "react-redux";
import styled from "styled-components";
import HeaderContainer from "../Header/LandingHeader/HeaderContainer"
import Footer from "../Footer/footer";
import MyCalendar from "./mycalendar.js";
import Header from "../Header/header";
import { Layoutstyled, Contentstyled } from "../Constants/style";
import { Layout, message, Spin, Row } from "antd";

/*const Siderstyled = styled(Sider)`
  background-color: pink !important;
`;*/

const WhiteLayout = styled(Layout)`
  background-color: white !important;
`;

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  async componentDidMount() {
    try {
      this.currentUser = await Parse.User.current().fetch();
      if (this.currentUser === null || this.currentUser === undefined) {
        this.props.userDisconnected();
        this.setState({ redirectToHomePage: true });
        return message.warn("Ta session a expiré, reconnecte-toi !");
      }
      if (this.currentUser.attributes !== undefined) {
        this.setState({ attributes: this.currentUser.attributes });
      }
      this.setState({ loading: false });
    } catch (error) {
      console.log("error : ", error);
      if (error.code === 209 || error.message === "invalid session token") {
        console.log("invalid session token");
        this.props.userDisconnected();
        this.setState({ redirectToHomePage: true });
        return message.warn("Ta session a expiré, reconnecte-toi !");
      }
    }
  }

  render() {
    if (this.state.loading === true) {
      return (
        <Layoutstyled>
          <Header />
          <HeaderContainer />
          <Contentstyled>
            <Row
              style={{ marginTop: "200px" }}
              type="flex"
              justify="center"
              align="middle"
            >
              <Spin size="large" />
            </Row>
          </Contentstyled>
          <Footer />
        </Layoutstyled>
      );
    }
    if (this.currentUser.attributes.team === undefined) {
      return (
        <Layoutstyled>
          <Header />
          <HeaderContainer />
          <Contentstyled>
            <h4 style={{ textAlign: "center", marginTop: "15%" }}>
              {`Vous n'êtes pas encore dans une Team ! Veuillez attendre qu'un administrateur vous en attribue une. `}
            </h4>
          </Contentstyled>
          <Footer />
        </Layoutstyled>
      );
    } else {
      return (
        <Layoutstyled>
          <Header />
          <HeaderContainer />
          <WhiteLayout>
            <Contentstyled>
              <Row style={{ marginLeft: "3.5%", marginRight: "3.5%" }}>
                <MyCalendar />
              </Row>
            </Contentstyled>
          </WhiteLayout>
          <Footer />
        </Layoutstyled>
      );
    }
  }
}

const mapStateToProps = globalReducers => globalReducers;

const mapDispatchToProps = dispatch => {
  return {
    userDisconnected() {
      Parse.User.logOut();
      dispatch({ type: "disconnect" });
    }
  };
};

const connectedCalendar = connect(
  mapStateToProps,
  mapDispatchToProps
)(Calendar);
export default connectedCalendar;
